import { Instance } from 'mobx-state-tree';
import { PlanningNotificationsResponseModelBase } from './PlanningNotificationsResponseModel.base';

/* The TypeScript type of an instance of PlanningNotificationsResponseModel */
export interface PlanningNotificationsResponseModelType extends Instance<typeof PlanningNotificationsResponseModel.Type> {}

/* A graphql query fragment builders for PlanningNotificationsResponseModel */
export { selectFromPlanningNotificationsResponse, planningNotificationsResponseModelPrimitives, PlanningNotificationsResponseModelSelector } from './PlanningNotificationsResponseModel.base';

/**
 * PlanningNotificationsResponseModel
 */
export const PlanningNotificationsResponseModel = PlanningNotificationsResponseModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
